import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { COOKIES_LOOKUP, SessionStatus } from 'src/services/auth/constants';
import { useZillowSession } from 'src/services/auth/session/hooks/useZillowSession';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
type DatadogCurrentUserConfig = {
    id: string;
    name: string;
    email: string;
    loanID?: string;
    anonymousID?: string;
};
export const useDatadogProviderState = ({ loanID, trackingID }: { loanID: MaybeLoanID; trackingID: string }) => {
    const { session, status } = useZillowSession();
    useEffect(() => {
        const setCurrentUserOnLoad = () => {
            if (status !== SessionStatus.LOADING && session?.user) {
                const currentUserConfig: DatadogCurrentUserConfig = {
                    id: session.user.zuid ?? Cookies.get(COOKIES_LOOKUP.SESSION_GUID) ?? 'No User ID Available',
                    name: session.user.name ?? 'No Name Available',
                    email: session.user.email ?? 'No Email Available',
                    anonymousID: trackingID,
                };

                if (loanID) {
                    currentUserConfig.loanID = loanID;
                }

                currentUserConfig.anonymousID = trackingID;

                DatadogRUMService.Client.getInstance().setUser(currentUserConfig);
            }
        };
        setCurrentUserOnLoad();

        return () => {
            DatadogRUMService.Client.getInstance().clearIdempotencyHistory();
        };
    }, [session?.user, status, loanID, trackingID]);
};
